import { render, staticRenderFns } from "./AddGas.vue?vue&type=template&id=c5826238&"
import script from "./AddGas.vue?vue&type=script&lang=js&"
export * from "./AddGas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports